module.exports = require('./dist/module-loader');


//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/module-loader.js
// module id = 620
// module chunks = 0